export default function useSlotHandle(props) {
  /**
   * Determines whether the user is allowed to select periods of time that are occupied by events
   * @type {import('@fullcalendar/core').OverlapFunc}
   */
  function onSelectOverlap(event) {
    return (
      event.display === 'background' &&
      event.extendedProps.type === 'appointment-type'
    )
  }

  /**
   * Triggered when a date/time selection is made
   * @param {import('@fullcalendar/core').DateSelectArg} value
   */
  function onSelectSlot(value) {
    if (!value.resource || !value.jsEvent) return

    props.slotRef.current = {
      schedule_note: {
        start: value.startStr,
        end: value.endStr,
        selected_resources: [value.resource.id],
      },
    }
  }

  /**
   * Triggered when the current selection is cleared
   * @param {import('@fullcalendar/core').DateUnselectArg} value
   */
  function onUnselectSlot(value) {
    props.setShowSlotDialog(false)
    props.slotRef.current = {
      schedule_note: null,
    }
  }

  return {
    onSelectOverlap,
    onSelectSlot,
    onUnselectSlot,
  }
}
